export interface AppState {
    connection: Connection,
    messages: TextMessage[],
    users?: Users,
    currentUser?: User,
    documentId?: number,
    documentTitle?: string
}

export interface TextMessage {
    id: string,
    text: string,
    senderId: number,
    createdAt: Date
}

export interface NewTextMessage {
    text: string,
    documentId: number
}

export interface Users {
    [id: number] : User
}

export interface User {
    id: number,
    email: string,
    name?: string,
    image_src?: string
}

export interface OldTextMessages {
    type: string,
    messages: TextMessage[],
    users: Users
}

export interface Connection {
    connectionState: ConnectionState,
    connectionId: string | null,
    socket: WebSocket | null
}

export enum ConnectionState {
    Init,
    WaitingForId,
    Connected,
    Error,
    NotAuthorized,
    Reconnecting,
}

